import React from 'react';

export const MEMBER_WELCOME_VIDEO_URL = 'https://player.mediadelivery.net/embed/612846/069e7e52-c633-46a2-a7a9-374b6f098e59';

export default function MemberWelcomeVideo({ onContinue }) {
    const [loading, setLoading] = React.useState(true);
    const [saving, setSaving] = React.useState(false);
    const [error, setError] = React.useState('');
    React.useEffect(() => {
        let active = true;
        fetch('/api/member_welcome_video', { credentials: 'same-origin', cache: 'no-store' })
            .then(response => {
                if (!response.ok) throw new Error('Welcome status unavailable');
                return response.json();
            })
            .then(data => {
                if (!active) return;
                if (data.seen === true) onContinue();
                else setLoading(false);
            })
            // A failed lookup must not silently mark or skip an unseen welcome.
            .catch(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [onContinue]);

    async function acknowledge() {
        if (saving) return;
        setSaving(true);
        setError('');
        try {
            const response = await fetch('/api/member_welcome_video', {
                method: 'POST', credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' }, body: '{}',
            });
            if (!response.ok || (await response.json()).seen !== true) throw new Error('Save failed');
            onContinue();
        } catch (_) {
            setError('We could not save your acknowledgment. Try Continue again, or continue without saving; the welcome may appear next login.');
            setSaving(false);
        }
    }

    return (
        <div role="dialog" aria-modal="true" aria-labelledby="member-welcome-title" style={{position:'fixed', inset:0, zIndex:3000, display:'flex', alignItems:'center', justifyContent:'center', padding:18, background:'rgba(0,0,0,.86)'}}>
            <section style={{width:'min(860px,100%)', maxHeight:'95vh', overflow:'auto', borderRadius:20, padding:20, background:'#fff', color:'#171411', boxShadow:'0 25px 80px #0008'}}>
                <h2 id="member-welcome-title" style={{fontSize:26, margin:'0 0 12px'}}>Welcome to your account</h2>
                {loading ? <p role="status">Loading your welcome…</p> : <>
                    <p style={{marginBottom:16}}>A short introduction to help you get started. You can continue whenever you are ready.</p>
                    <iframe title="Member welcome video" src={`${MEMBER_WELCOME_VIDEO_URL}?autoplay=false&loop=false`} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={{display:'block', width:'100%', aspectRatio:'16 / 9', border:0, background:'#000'}} />
                    {error && <p role="alert" style={{marginTop:12}}>{error}</p>}
                    <button type="button" autoFocus disabled={saving} onClick={acknowledge} style={{marginTop:18, padding:'12px 28px', borderRadius:30, border:0, background:'#e3b94d', color:'#171411', fontWeight:700, cursor:'pointer'}}>{saving ? 'Saving…' : 'Continue'}</button>
                    {error && <button type="button" onClick={onContinue} style={{marginLeft:12, padding:12}}>Continue without saving</button>}
                </>}
            </section>
        </div>
    );
}
